// extracted by mini-css-extract-plugin
export default {"container":"Header_container__rpi9X","title":"Header_title__jHY8F"};